<template>
  <ion-card data-test="card-content-skeleton">
    <ion-card-header>
      <ion-card-title>
        <ion-skeleton-text
          data-test="title"
          style="width: 80%; height: 22px"
          :animated="true"
        ></ion-skeleton-text
      ></ion-card-title>

      <ion-skeleton-text
        data-test="icon"
        :animated="true"
        class="icon-wrapper"
      ></ion-skeleton-text>
    </ion-card-header>
    <ion-card-content>
      <ion-skeleton-text
        data-test="description"
        :animated="true"
        style="width: 100%; height: 14px"
      ></ion-skeleton-text>
    </ion-card-content>
    <div class="button">
      <ion-skeleton-text
        data-test="button"
        :animated="true"
        style="width: 30%; height: 30px"
      ></ion-skeleton-text>
    </div>
  </ion-card>
</template>

<script setup lang="ts">
import {
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonSkeletonText,
} from "@ionic/vue";
</script>

<style lang="scss" scoped>
ion-card {
  align-items: flex-start;
  background-color: var(--background-white);
  border-radius: 24px;
  border: 2px solid var(--light-grey-border);
  box-shadow: none;
  display: flex;
  flex-direction: column;
  height: 200px;
  margin: var(--spacing-0);
  max-width: 584px;
  padding: var(--spacing-24);
}

ion-card-header {
  padding: var(--spacing-0);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--spacing-8);
  width: 100%;
}

ion-card-title {
  width: 90%;
}
ion-card-content {
  padding: var(--spacing-0);
  width: 100%;
}

.icon-wrapper {
  background-color: var(--surface-lighter-grey);
  border-radius: 50%;
  display: inline-block;
  height: 40px;
  width: 40px;
  margin: var(--spacing-0);
}

.button {
  width: 100%;
  margin-top: auto;
}
</style>
